import React from 'react';

const Search = () => {
    return (
        <div>
            <h1>Comeing soon</h1>
            
        </div>
    );
};

export default Search;